var Mezzanine = /** @class */ (function () {
    function Mezzanine(layoutComponent) {
        this.layoutComponent = layoutComponent;
        this.headerSelector = layoutComponent.headerSelector;
        this.footerSelector = layoutComponent.footerSelector;
    }
    Mezzanine.prototype.attach = function (clickListener) {
        this.clickListener = clickListener;
        if (this.cachedHeader) {
            this.cachedHeader.addEventListener('click', this.clickListener);
        }
    };
    Mezzanine.prototype.detach = function () {
        if (this.cachedHeader) {
            this.cachedHeader.removeEventListener('click', this.clickListener);
        }
    };
    Mezzanine.prototype.getHeader = function () {
        if (!this.cachedHeader || this.layoutComponent.headerSelector !== this.headerSelector) {
            this.cachedHeader = document.querySelector(this.headerSelector);
            this.headerSelector = this.layoutComponent.headerSelector;
            this.attach(this.clickListener);
        }
        return this.cachedHeader;
    };
    Mezzanine.prototype.getFooter = function () {
        if (!this.cachedFooter || this.layoutComponent.footerSelector !== this.footerSelector) {
            this.cachedFooter = document.querySelector(this.footerSelector);
            this.footerSelector = this.layoutComponent.footerSelector;
        }
        return this.cachedFooter;
    };
    Mezzanine.prototype.getHeaderHeight = function () {
        var header = this.getHeader();
        if (!header) {
            return 0;
        }
        return header.getBoundingClientRect().height;
    };
    Mezzanine.prototype.getFooterHeight = function () {
        var footer = this.getFooter();
        if (!footer) {
            return 0;
        }
        return footer.getBoundingClientRect().height;
    };
    Mezzanine.prototype.getVisibleHeaderHeight = function () {
        var header = this.getHeader();
        if (!header) {
            return 0;
        }
        var boundingBox = header.getBoundingClientRect();
        return Math.max(boundingBox.top + boundingBox.height, 0);
    };
    return Mezzanine;
}());
export default Mezzanine;
//# sourceMappingURL=mezzanine.js.map